import ChapterSlideshow from "components/Navigation/ChapterList/ChapterSlideshow";
import getNeedsModifiedScrollbars from "selectors/device/getNeedsModifiedScrollbars";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => ({
  needsModifiedScrollbars: getNeedsModifiedScrollbars(state, ownProps),
});

const connector = connect(mapStateToProps);

export default connector(ChapterSlideshow);
